// angular
// 	.module("HeroPRO")
// 	.controller("OfficeProfileController", officeProfileController);

import _ from 'lodash';
import './officeProfile.scss';

/* @ngInject */
export default function officeProfileController(OfficesFactory, $stateParams, $window, $rootScope, $analytics, UserData, HPRoles, HPConfig, CommonDataFactory) {
    const vm = this;

    vm.profileDetail = {};
    vm.locationDetail = {};
    vm.officeDescription = '';
    vm.officeWebsite = '';
    vm.maxDescriptionLength = 8000;

    // Flags
    vm.canViewACH = false;
    vm.isEditingProfile = false;
    vm.submitted = false;
    vm.canEditDescription = true;

    // Logo
    vm.logoImage = null;
    vm.logoFileName = '';
    vm.displayLogo = false;

    // Errors
    vm.description = '';
    vm.uploadErrorMessage = '';
    vm.countiesErrorMessage = '';

    // state
    vm.selectedState = {
        IsActive: true,
        Name: '',
        StateAbbreviation: '',
        StateFIPSPrefix: '',
        StateGeoId: -1,
    };
    vm.activeStates = [];
    let allStates = [];

    // Counties/Municipalities
    vm.counties = [];
    vm.currentCounties = [];
    let fullCountyList = [];

    // Primary Service
    vm.selectedPrimaryService = null;
    vm.defaultServiceType = {
        Description: 'Choose one',
        Name: 'null',
        ContractorTypeId: -1,
    };

    // Additional Services
    vm.primaryService = {};
    vm.secondaryServices = [];
    vm.availableServices = [];
    vm.contractorServiceTypes = [];

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

    vm.editProfile = function () {
        vm.isEditingProfile = true;

        // If a Primary Service does not exist, set the select Primary Service to the default value
        if (!hasPrimaryService()) {
            vm.selectedPrimaryService = vm.defaultServiceType;
        }
    };

    vm.cancelEditProfile = function () {
    // Reordered function calls to clear state and then restore last loaded values on cancel.
        clearUIState();
        setDatabindings();
        getContractorServices();
        // Added function call to reload counties
        getCounties(vm.selectedState);
        // Null out Selected Primary Service if the default is currently "selected"
        if (!hasPrimaryService()) {
            vm.selectedPrimaryService = null;
        }
        vm.isEditingProfile = false;
        vm.submitted = false;
    };

    vm.submitOfficeProfile = function () {
    // Refactored to set submitted flag and corrected validation.
        vm.submitted = true;
        if (vm.editOfficeProfile.$valid && hasPrimaryService()) {
            const data = {
                ContractorLocationId: $stateParams.accountId,
                ProfileDetail: {
                    CompanyOverview: vm.officeDescription,
                    CompanyURL: vm.officeWebsite,
                    LogoFilename: vm.logoFileName,
                    ContractorTypes: prepServicesForSave(),
                    Munis: prepMunisForSave(),
                },
            };
            saveProfile(data);
        }
    };

    vm.selectCounty = function (selectedCounty) {
        let county = _.find(vm.counties[0], item => item.MuniId === selectedCounty.MuniId);
        if (county !== null && county !== undefined) {
            county.isSelected = !county.isSelected;
        } else {
            county = _.find(vm.counties[1], item => item.MuniId === selectedCounty.MuniId);
            if (county !== null && county !== undefined) {
                county.isSelected = !county.isSelected;
            }
        }
    };

    vm.primaryServiceClicked = function (service) {
        service.isSelected = true;
        vm.selectedPrimaryService = service;
        vm.contractorServiceTypes = _.without(vm.contractorServiceTypes, vm.defaultServiceType);
        vm.availableServices = _.without(
            vm.contractorServiceTypes,
            _.findWhere(vm.contractorServiceTypes, vm.selectedPrimaryService),
        );

        // Check if selected primary is a secondary
        const secService = _.find(vm.secondaryServices, secSvc => secSvc.ContractorTypeId === service.ContractorTypeId);

        if (secService !== undefined && secService !== null) {
            vm.secondaryServices = _.without(vm.secondaryServices, secService);
        }

        _.each(vm.secondaryServices, (secSvc) => {
            vm.availableServices = _.without(vm.availableServices, _.find(vm.availableServices, service => service.ContractorTypeId === secSvc.ContractorTypeId));
        });

        validatePrimaryService();
    };

    vm.addService = function () {
        vm.secondaryServices.push({});
    };

    vm.secondaryServiceClicked = function (type, index) {
        vm.secondaryServices[index] = type;
        vm.availableServices = _.map(vm.contractorServiceTypes, _.clone);
        vm.availableServices = _.without(vm.availableServices, _.find(vm.availableServices, svc => svc.ContractorTypeId === vm.selectedPrimaryService.ContractorTypeId));
        // Rebuild available list
        _.each(vm.secondaryServices, (selSvc) => {
            vm.availableServices = _.without(vm.availableServices, _.find(vm.availableServices, availSvc => availSvc.ContractorTypeId === selSvc.ContractorTypeId));
        });
    };

    vm.removeService = function (type) {
        vm.secondaryServices = _.without(vm.secondaryServices, _.find(vm.secondaryServices, svc => svc.ContractorTypeId === type.ContractorTypeId));
        vm.availableServices = _.map(vm.contractorServiceTypes, _.clone);
        vm.availableServices = _.without(vm.availableServices, _.find(vm.availableServices, svc => svc.ContractorTypeId === vm.selectedPrimaryService.ContractorTypeId));
        // Rebuild available list
        _.each(vm.secondaryServices, (selSvc) => {
            vm.availableServices = _.without(vm.availableServices, _.find(vm.availableServices, availSvc => availSvc.ContractorTypeId === selSvc.ContractorTypeId));
        });
        vm.availableServices = _.sortBy(vm.availableServices, 'ContractorTypeId');
    };

    vm.calcCharactersRemaining = function () {
        if (vm.officeDescription !== undefined && vm.officeDescription !== null && vm.officeDescription !== '') {
            return vm.maxDescriptionLength - vm.officeDescription.replace(/\n/g, '\r\n').length;
        }
        return vm.maxDescriptionLength;
    };

    vm.navigateToWebsite = function () {
        const url = (vm.profileDetail.CompanyURL.toLowerCase().indexOf('http://') >= 0) ? vm.profileDetail.CompanyURL : `http://${vm.profileDetail.CompanyURL}`;
        $window.open(
            url,
            '_blank',
        );
    };

    vm.uploadButtonClicked = function ($event) {
        $event.preventDefault();
    };

    vm.checkState = function () {
    // Removed indexOf condition and replaced with _.filter() to find activeState object in activeStates collection.
        const activeState = _.filter(vm.activeStates, state => state.StateGeoId === vm.selectedState.StateGeoId);

        // Added condition to check activeState length. Filter returns an empty array if no records match condition.
        // Refactored condition to return condition rather than explicit true/false
        return (vm.selectedState !== null && activeState !== undefined && activeState.length > 0);
    };

    /* -----  End of Public Functions  ------*/

    /*= =======================================
	 =            Private Functions            =
	 ======================================== */
    function init() {
        getOfficeProfile();

    //		$scope.$on("HPFileUploaded", function (event, args) {
    //			var fileName = args.Data.FileName;
    //			alert("Finish upload: " + fileName);
    //		});
    }

    function getOfficeProfile() {
        const data = {
            ContractorLocationId: Number($stateParams.accountId),
        };
        UserData.getUserData().then((response) => {
            const currentRole = _.find(HPRoles, (key, other) => other === response.Roles[0]);

            data.IncludeACHInfo = currentRole.isAdmin;
            OfficesFactory.getOfficeProfile(data).then((response) => {
                vm.profileDetail = response.data.ProfileDetail;
                vm.locationDetail = response.data.LocationDetail;
                vm.selectedState.StateAbbreviation = response.data.LocationDetail.State;
                getActiveStates(vm.selectedState);
                setDatabindings();
                getContractorServices();
            });
        });
    }

    function setDatabindings() {
        if (!!vm.profileDetail.CompanyOverview && vm.profileDetail.CompanyOverview.length > vm.maxDescriptionLength) {
            vm.officeDescription = vm.profileDetail.CompanyOverview.substring(0, vm.maxDescriptionLength).replace(
                /\n/g,
                '',
            );
        } else if (vm.profileDetail.CompanyOverview) {
            vm.officeDescription = vm.profileDetail.CompanyOverview.replace(/\n/g, '');
        }

        if (!!vm.profileDetail.IsCompliancePageEnabled && vm.profileDetail.IsCompliancePageEnabled === true) {
            vm.canEditDescription = false;
        }

        vm.officeWebsite = vm.profileDetail.CompanyURL;

        if (!!vm.profileDetail.LogoFilename && vm.profileDetail.LogoFilename !== '') {
            const logoUrl = HPConfig.rackspaceCdn + vm.profileDetail.LogoFilename;
            displayValidImage(logoUrl);
        }
    }

    function getContractorServices() {
        OfficesFactory.getServices().then((response) => {
            vm.contractorServiceTypes = _.sortBy(response.data.Data, 'ContractorTypeId');
            vm.availableServices = vm.contractorServiceTypes;
            getCurrentContractorServices();
        });
    }

    function getCurrentContractorServices() {
        const primary = _.filter(vm.profileDetail.ContractorTypes, serviceType => serviceType.IsPrimaryType === true);
        if (primary[0] !== undefined) {
            vm.selectedPrimaryService = primary[0];
            _.each(vm.contractorServiceTypes, (svcType) => {
                if (svcType.ContractorTypeId === vm.selectedPrimaryService.ContractorTypeId) {
                    vm.selectedPrimaryService.Description = svcType.Description;
                }
            });
            vm.availableServices = _.without(vm.availableServices, _.find(vm.availableServices, service => service.ContractorTypeId === vm.selectedPrimaryService.ContractorTypeId));
        } else {
            // Added missing else when no Primary Service Type exists.
            if (_.findWhere(vm.contractorServiceTypes, { ContractorTypeId: -1 }) === undefined) {
                vm.contractorServiceTypes.unshift(vm.defaultServiceType);
            }
        }

        vm.secondaryServices = _.filter(vm.profileDetail.ContractorTypes, serviceType => serviceType.IsPrimaryType === false);

        _.each(vm.contractorServiceTypes, (svcType) => {
            _.each(vm.secondaryServices, (secSvc) => {
                if (svcType.ContractorTypeId === secSvc.ContractorTypeId) {
                    secSvc.Description = svcType.Description;
                }
            });
        });

        _.each(vm.secondaryServices, (secSvc) => {
            vm.availableServices = _.without(vm.availableServices, _.find(vm.availableServices, service => service.ContractorTypeId === secSvc.ContractorTypeId));
        });
    }

    /* modified need to return getStates to true and not use var allStates */
    function getActiveStates(currentState) {
        if (vm.activeStates.length > 0) {
            setActiveState(vm.activeStates, currentState);
            getCounties(vm.selectedState);
        } else {
            CommonDataFactory.getStates(true).then((response) => {
                allStates = response.data.Data;
                setSelectedState(allStates, vm.selectedState.StateAbbreviation);
                vm.activeStates = response.data.Data;
                setActiveState(allStates, currentState);
                if (vm.isEditingProfile === true) {
                    getCounties(vm.selectedState);
                } else {
                    loadCountiesByProfile();
                }
            });
        }
    }

    /* temp function to set state based on saved info */
    function setSelectedState(states, currentStateAbbr) {
        const matchedState = _.find(states, s => s.StateAbbreviation === currentStateAbbr);

        if (matchedState) {
            angular.copy(matchedState, vm.selectedState);
        }
    }

    function setActiveState(activeStates, currentState) {
        _.each(activeStates, (s) => {
            if (s === currentState) {
                vm.selectedState = currentState;
            }
        });

        if (!vm.selectedState) {
            vm.selectedState = activeStates[0];
        }
    }

    function getCounties(state) {
        console.log(state);
        vm.counties = [];
        if (fullCountyList.length === 0) {
            OfficesFactory.getCounties().then((response) => {
                fullCountyList = _.each(_.sortBy(response.data.Data.Munis, 'Name'), (item) => {
                    const matchingItem = _.find(vm.profileDetail.Munis, county => county.MuniId === item.MuniId);
                    if (matchingItem !== null && matchingItem !== undefined) {
                        return _.extend(item, {
                            isSelected: true,
                        });
                    }

                    return _.extend(item, {
                        isSelected: false,
                    });
                });

                if (!state) {
                    return;
                }

                createFilteredCountyListByState(state);
            });
        } else {
            createFilteredCountyListByState(state);
        }
    }

    // (jb 9/6/2016) added this to show all selected counties regardless of states on profile view
    function loadCountiesByProfile() {
        if (fullCountyList.length === 0) {
            OfficesFactory.getCounties().then((response) => {
                fullCountyList = _.each(_.sortBy(response.data.Data.Munis, 'Name'), (item) => {
                    const matchingItem = _.find(vm.profileDetail.Munis, county => county.MuniId === item.MuniId);
                    if (matchingItem !== null && matchingItem !== undefined) {
                        return _.extend(item, {
                            isSelected: true,
                        });
                    }

                    return _.extend(item, {
                        isSelected: false,
                    });
                });
                formatCounties(filterCountiesByState(vm.selectedState));
                getCurrentCounties(fullCountyList);
            });
        } else {
            formatCounties(filterCountiesByState(vm.selectedState));
            getCurrentCounties(fullCountyList);
        }
    }

    function createFilteredCountyListByState(state) {
        formatCounties(filterCountiesByState(state));
        getCurrentCounties(filterCountiesByState(state));
    }

    function filterCountiesByState(state) {
        if (!state) {
            return fullCountyList;
        }

        return _.filter(fullCountyList, f =>
            f.StateGeoId === state.StateGeoId, // angular.equals(f.FIPSCode.substring(0, 2), state.StateFIPSPrefix);
        );
    }

    function formatCounties(counties) {
        vm.counties = [];
        let firstHalfCounties = [],
            secondHalfCounties = [];

        if (counties.length > 1) {
            firstHalfCounties = counties.slice(0, counties.length / 2);
            vm.counties.push(firstHalfCounties);

            secondHalfCounties = counties.slice(counties.length / 2);
            vm.counties.push(secondHalfCounties);
        } else {
            vm.counties.push(counties);
        }
    }

    function getCurrentCounties(fullCountyList) {
        vm.currentCounties = [];
        const currentCounties = _.filter(fullCountyList, county => county.isSelected === true);

        const position = (currentCounties.length % 2 === 0) ? currentCounties.length / 2 : ((currentCounties.length / 2) + 1);

        const firstHalfCurrentCounties = currentCounties.slice(0, position);
        const secondHalfCurrentCounties = currentCounties.slice(position);
        vm.currentCounties.push(firstHalfCurrentCounties);
        vm.currentCounties.push(secondHalfCurrentCounties);
    }

    function prepServicesForSave() {
        const currentSelectedServices = [];
        _.each(vm.secondaryServices, (service) => {
            if (service.ContractorTypeId !== undefined && service.ContractorTypeId !== null) {
                currentSelectedServices.push({
                    ContractorTypeId: service.ContractorTypeId,
                    IsPrimaryType: false,
                });
            }
        });
        currentSelectedServices.push({
            ContractorTypeId: vm.selectedPrimaryService.ContractorTypeId,
            IsPrimaryType: true,
        });
        return currentSelectedServices;
    }

    function prepMunisForSave() {
    // var munis = vm.counties[0].slice();
    // munis.push.apply(munis, vm.counties[1]);
    /* temporary fix for production MO offices */
        const filteredMunis = _.filter(fullCountyList, muni => muni.isSelected === true);
        const currentMunis = [];
        _.each(filteredMunis, (muni) => {
            currentMunis.push({
                MuniId: muni.MuniId,
            });
        });
        return currentMunis;
    }

    // Boolean function to test if a ContractorType is selected
    function hasPrimaryService() {
        if (!vm.selectedPrimaryService || vm.selectedPrimaryService.ContractorTypeId === -1) {
            return false;
        }

        return true;
    }

    // Function to set form validity based on if ContractorType is set.
    function validatePrimaryService() {
        if (hasPrimaryService()) {
            vm.editOfficeProfile.$setValidity('noservicetype', true);
        } else {
            vm.editOfficeProfile.$setValidity('noservicetype', false);
        }
    }

    // j.b. can no longer save munis by single state
    function saveProfile(data) {
        OfficesFactory.saveProfile(data).then((response) => {
            vm.isEditingProfile = false;
            vm.profileDetail = response.data.Data.ProfileDetail;
            setDatabindings();
            getContractorServices();
            // getCounties(vm.selectedState);
            loadCountiesByProfile();
        });
    }

    function clearUIState() {
    // Added additional values to clear.
        fullCountyList = [];
        vm.officeDescription = '';
        vm.officeWebsite = '';
        vm.selectedPrimaryService = null;
        vm.logoImage = null;
        vm.uploadErrorMessage = '';
        vm.countiesErrorMessage = '';
    }

    function displayValidImage(url) {
        OfficesFactory.validateImage(url).then((response) => {
            vm.displayLogo = response;
            if (vm.displayLogo) {
                vm.logoFileName = vm.profileDetail.LogoFilename;
                vm.logoImage = HPConfig.rackspaceCdn + vm.profileDetail.LogoFilename;
            }
        });
    }

    $rootScope.$watch(() => vm.logoImage, (val) => {
        if (val !== undefined && val !== null) {
            vm.uploadErrorMessage = '';
            vm.displayLogo = true;
        }
    });

    $rootScope.$watch(() => vm.selectedState, (val, oldval) => {
        if (!angular.equals(val, oldval)) {
            if (!val) {
                return;
            }
            getCounties(vm.selectedState);
        }
    });

    $rootScope.$on('editLogoInvalidUploadType', (event, payload) => {
        vm.uploadErrorMessage = 'That file is not a jpeg, jpg, tiff, gif, bmp, or png.';
        $analytics.eventTrack('Invalid Logo Upload', { category: 'Edit Office', label: `File Extension: ${payload.fileType}` });
    });

    $rootScope.$on('editLogoInvalidUploadSize', () => {
        vm.uploadErrorMessage = 'That file is larger than 10 MB.';
    });

    $rootScope.$on('editLogoStartUpload', (event, payload) => {
        OfficesFactory.saveLogo(payload).then((response) => {
            vm.logoImage = HPConfig.rackspaceCdn + response.data.Data.FileName;
            vm.logoFileName = response.data.Data.FileName;
            vm.uploadErrorMessage = '';
        });
    });
}



// WEBPACK FOOTER //
// ./src/app/accounts/offices/profile/officeProfileController.js